<div class="content">
    <form class="example-form">
        <div class="form-container">
            <mat-form-field class="example-full-width">
                <mat-label>{{ "visibility.labels.newGroup" | translate }}</mat-label>
                <input type="groupName" matInput [formControl]="groupName">
                <mat-error *ngIf="groupName.hasError('required')"></mat-error>
            </mat-form-field>

            <div class="email-input">
                <mat-form-field class="example-full-width">
                    <mat-label>{{ "visibility.labels.email" | translate }}</mat-label>
                    <input type="email" matInput [formControl]="emailFormControl" placeholder="Ex. pat@example.com" />
                    <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
                        {{"permissions.email.invalidEmail" | translate}}
                    </mat-error>
                    <mat-error *ngIf="emailFormControl.hasError('invalidUser')">
                        {{"permissions.email.emailNotFound" | translate}}
                    </mat-error>
                    <mat-error *ngIf="emailFormControl.hasError('required')">
                        {{"permissions.email.emailIsRequired" | translate}}
                    </mat-error>
                </mat-form-field>
                <div class="button-container">
                    <button mat-raised-button color="primary" (click)="addEmailToList()" [disabled]="addButtonDisabled">
                        {{ "visibility.labels.toAdd" | translate }}
                    </button>
                </div>
            </div>
        </div>
        <mat-table [dataSource]="userList" class="mat-elevation-z8">
            <ng-container matColumnDef="email">
                <mat-header-cell *matHeaderCellDef>{{ "visibility.labels.emails" | translate}}</mat-header-cell>
                <mat-cell *matCellDef="let user" [ngClass]="user.invalid ? 'invalid-user' : ''">{{ user.email }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="remove">
                <mat-header-cell *matHeaderCellDef class="text-center">{{ "visibility.labels.actions" |
                    translate}}</mat-header-cell>
                <mat-cell *matCellDef="let user" class="mat-column-remove">
                    <button mat-raised-button (click)="removeEmail(user.email)">
                        {{ "visibility.labels.remove" | translate}}
                    </button>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayColumn"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayColumn"></mat-row>
        </mat-table>
        <div class="button-container-save">
            <button mat-raised-button (click)="onCloseClick()">{{ "visibility.labels.close" | translate}}</button>
            <button mat-raised-button color="primary" (click)="onSave()">{{ "visibility.labels.save" | translate}}</button>
        </div>
    </form>
</div>